import { styled } from "styled-components";

export const PageSection = styled.div`
    background: linear-gradient(180deg,#f9f6f2 54%,#f2efff);
    // height: 100vh;
    // width: 100vw;
    // display: flex;
    // flex-direction: column;
`

export const PageContent = styled.div`
    /* padding-left: 260px; */

    /* @media (max-width: 768px) {
        padding-left: 0;
    } */
`